import React, { useCallback } from 'react'
import { makeStyles, Button } from '@material-ui/core'
import clsx from 'clsx'
import noop from 'lodash/noop'
import { Link, useHistory } from 'react-router-dom'
import OperationalTable, { useOperationalTable } from '../../../organisms/OperationalTable'
import CSVButton from '../../../atoms/CSVButton'
import ExportCsvButton from '../../../molecules/ExportCsvButton'
import { defaultColumnConfig, USERS_PATH } from './helpers'
import { useUsersCSVData, useSearchUsers } from './hooks'

const useStyles = makeStyles((theme) => ({
  headspace: {
    paddingTop: '1rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  container: {
    padding: '1rem'
  },
  addButton: {
    padding: '0 1rem 0 .7rem',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    fill: theme.palette.getContrastText(theme.palette.primary.main),
    transition: 'color .3s ease-in-out',
    '&:hover': {
      backgroundColor: theme.palette.gray.main,
      color: theme.palette.getContrastText(theme.palette.gray.main)
    },
    marginRight: '10px'
  },
  button: {
    borderRadius: '30px',
    fontWeight: 800
  },
  link: {
    textDecoration: 'none !important'
  }
}))

function UsersView () {
  const history = useHistory()
  const {
    defaultPageSize,
    pageIndex,
    pageSize,
    sort,
    searchText,
    onPagingChange,
    onSortingChange,
    onSearchTextChange,
    onTableModeChange,
    tableMode
  } = useOperationalTable(defaultColumnConfig.defaultSort)
  const classes = useStyles()

  const onClickRow = useCallback((row) => {
    if (row.original) {
      history.push(`${USERS_PATH}/${row.original.userId}`)
    }
  }, [history])

  const { data = [], loading, count = 0 } = useSearchUsers({
    pageIndex,
    pageSize,
    sort,
    searchText,
    tableMode
  })

  const csvData = useUsersCSVData({ data, columns: defaultColumnConfig.columns })

  return (
    <div className={classes.container}>
      <OperationalTable.Wrapper>
        <OperationalTable.SuperHeader className={classes.headspace}>
          <OperationalTable.Search
            onChange={onSearchTextChange}
            placeholder='Search for a user'
            delay={250}
          />
          <div>
            <Link to={`${USERS_PATH}/new`} className={classes.link}>
              <Button
                className={clsx(classes.button, classes.addButton)}
                onClick={noop}
              >
                Add user
              </Button>
            </Link>
            <CSVButton data={csvData} fileName='users_list_export'>
              <ExportCsvButton />
            </CSVButton>
          </div>
        </OperationalTable.SuperHeader>
        <OperationalTable
          mode='server'
          columns={defaultColumnConfig.columns}
          data={data}
          defaultPageSize={defaultPageSize}
          defaultSort={defaultColumnConfig.defaultSort}
          itemName='Users'
          loading={loading}
          total={count}
          searchText={searchText}
          onSortingChange={onSortingChange}
          onPagingChange={onPagingChange}
          onTableModeChange={onTableModeChange}
          onRowClick={onClickRow}
        />
      </OperationalTable.Wrapper>
    </div>
  )
}

export default UsersView
